export const sv = {
  app: {
    skip: 'Hoppa till innehållet',
    offline: 'Du är offline. Ändringar sparas inte förrän anslutningen är tillbaka.',
  },
  nav: {
    main: 'Huvudmeny',
    calendar: 'Kalender',
    rooms: 'Rum',
    bookings: 'Mina bokningar',
    admin: 'Administration',
    profile: 'Profil',
    signOut: 'Logga ut',
    language: 'English',
  },
  common: {
    save: 'Spara',
    cancel: 'Avbryt',
    close: 'Stäng',
    edit: 'Redigera',
    remove: 'Ta bort',
    back: 'Tillbaka',
    loading: 'Laddar…',
    yes: 'Ja',
    no: 'Nej',
    saved: 'Sparat.',
    people: 'personer',
    floor: 'Plan',
    name: 'Namn',
    email: 'E-post',
    search: 'Sök',
    all: 'Alla',
    active: 'Aktiv',
    inactive: 'Inaktiverad',
    from: 'Från',
    to: 'Till',
    date: 'Datum',
    start: 'Start',
    end: 'Slut',
    copy: 'Kopiera',
    copied: 'Kopierat!',
    download: 'Ladda ner',
    confirm: 'Bekräfta',
    retry: 'Försök igen',
    none: 'Inget att visa.',
  },
  login: {
    title: 'Logga in',
    email: 'E-postadress',
    password: 'Lösenord',
    submit: 'Logga in',
    forgot: 'Glömt lösenordet?',
    failed: 'Fel e-postadress eller lösenord.',
    code: 'Kod från din autentiseringsapp',
    codeHint:
      'Öppna appen (t.ex. Google Authenticator eller Microsoft Authenticator) och skriv in den sexsiffriga koden.',
    verify: 'Verifiera',
    badCode: 'Koden stämmer inte. Försök igen.',
    useBackup: 'Använd en reservkod',
    backupCode: 'Reservkod',
  },
  forgot: {
    title: 'Glömt lösenord',
    intro: 'Skriv din e-postadress så skickar vi en länk för att välja nytt lösenord.',
    submit: 'Skicka länk',
    sent: 'Om adressen finns hos oss har vi skickat en länk. Den gäller i en timme.',
  },
  reset: {
    title: 'Välj nytt lösenord',
    submit: 'Spara lösenord',
    done: 'Lösenordet är bytt. Logga in med det nya lösenordet.',
    invalid: 'Länken är ogiltig eller har gått ut. Be om en ny.',
  },
  invite: {
    title: 'Välkommen, {{name}}!',
    intro: 'Välj ett lösenord för {{email}}. Du loggar in med din e-postadress.',
    submit: 'Skapa konto',
    done: 'Klart! Nu kan du logga in.',
    invalid: 'Länken är ogiltig, redan använd eller har gått ut. Be receptionen om en ny.',
  },
  confirmEmail: {
    title: 'Bekräfta e-postadress',
    done: 'E-postadressen är ändrad till {{email}}.',
    invalid: 'Länken är ogiltig eller har gått ut.',
  },
  password: {
    new: 'Nytt lösenord',
    repeat: 'Upprepa lösenordet',
    rules:
      'Minst 10 tecken. Vanliga lösenord godtas inte. Tips: flera ord i följd, t.ex. "kanel-tåg-solsken".',
    mismatch: 'Lösenorden är inte lika.',
  },
  twofa: {
    title: 'Tvåstegsinloggning',
    intro:
      'Som personal behöver du tvåstegsinloggning. Du behöver en autentiseringsapp i telefonen.',
    step1: 'Bekräfta ditt lösenord för att börja.',
    step2: 'Skanna QR-koden med appen, eller skriv in nyckeln för hand.',
    key: 'Nyckel',
    step3: 'Skriv in koden som appen visar.',
    backup: 'Reservkoder',
    backupIntro:
      'Spara de här koderna på ett säkert ställe. Varje kod kan användas en gång om du tappar bort telefonen.',
    done: 'Tvåstegsinloggning är på.',
    continue: 'Fortsätt',
  },
  cal: {
    day: 'Dag',
    week: 'Vecka',
    month: 'Månad',
    today: 'Idag',
    prev: 'Föregående',
    next: 'Nästa',
    newBooking: 'Ny bokning',
    find: 'Hitta ledigt rum',
    hint: 'Tryck i kalendern för att boka.',
    busy: 'Upptaget',
    blocked: 'Blockerat',
    mine: 'Min bokning',
    room: 'Rum',
    dst: 'Tidsomställning denna dag (23 eller 25 timmar).',
    tz: 'Alla tider är svensk tid',
    noRooms: 'Du har inga rum att boka. Kontakta receptionen.',
    freeNow: 'Ledigt nu',
    busyNow: 'Upptaget nu',
    bookings: '{{count}} bokningar',
    bookings_one: '{{count}} bokning',
    continues: 'fortsätter',
  },
  booking: {
    new: 'Ny bokning',
    edit: 'Ändra bokning',
    title: 'Rubrik',
    titlePlaceholder: 'Möte',
    attendees: 'Antal personer',
    room: 'Rum',
    startDate: 'Startdatum',
    startTime: 'Starttid',
    endDate: 'Slutdatum',
    endTime: 'Sluttid',
    repeat: 'Upprepa',
    repeatNone: 'Nej',
    repeatCount: 'Varje vecka, antal gånger',
    repeatUntil: 'Varje vecka till och med',
    times: 'Antal gånger',
    until: 'Till och med',
    book: 'Boka',
    booked: 'Bokat!',
    bookedSeries: '{{count}} bokningar skapade.',
    forUser: 'Boka åt',
    forMe: 'Mig själv',
    override: 'Boka ändå (fler än rummet rymmer)',
    cancel: 'Avboka',
    cancelOne: 'Bara den här',
    cancelFollowing: 'Den här och alla efterföljande',
    cancelConfirm: 'Vill du avboka?',
    cancelled: 'Avbokat.',
    endEarly: 'Avsluta nu',
    endedEarly: 'Bokningen är avslutad och rummet ledigt.',
    scopeQuestion: 'Gäller ändringen',
    saveChanges: 'Spara ändringar',
    series: 'Återkommande',
    reason: 'Orsak (visas för personen)',
    by: 'Bokad av',
    createdBy: 'Skapad av',
    company: 'Företag',
    status: 'Status',
    statusActive: 'Aktiv',
    statusCancelled: 'Avbokad',
    clashes: 'De här tillfällena krockar, så inget har bokats:',
    clashBooking: 'upptaget',
    clashBlock: 'blockerat',
    capacity: 'Rummet rymmer {{count}} personer.',
    multiDay: 'Flera dagar',
    started: 'Pågår',
  },
  find: {
    title: 'Hitta ledigt rum',
    search: 'Sök',
    none: 'Inga lediga rum för den tiden.',
    book: 'Boka',
  },
  rooms: {
    equipment: 'Utrustning',
    layout: 'Möblering',
    description: 'Beskrivning',
    book: 'Boka',
    capacity: 'Kapacitet',
    noPhoto: 'Foto saknas',
    qr: 'QR-skylt',
    inactive: 'Ej bokningsbart',
  },
  mine: {
    upcoming: 'Kommande',
    past: 'Tidigare',
    none: 'Inga bokningar.',
    notifications: 'Notiser',
    noNotifications: 'Inga notiser.',
    markRead: 'Markera som lästa',
  },
  profile: {
    title: 'Profil',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    language: 'Språk',
    company: 'Företag',
    reminder: 'Påminnelse före möten',
    reminderOff: 'Av',
    minutes: '{{count}} minuter',
    hours: '{{count}} timmar',
    calendar: 'Kalenderlänk',
    calendarIntro:
      'Prenumerera på dina bokningar i Outlook, Google Kalender eller Apple Kalender. Länken är personlig, dela den inte.',
    calendarNew: 'Skapa ny länk',
    calendarNewConfirm: 'Den gamla länken slutar fungera. Fortsätta?',
    changePassword: 'Byt lösenord',
    currentPassword: 'Nuvarande lösenord',
    passwordChanged: 'Lösenordet är bytt.',
    export: 'Mina uppgifter',
    exportIntro: 'Ladda ner alla dina bokningar som en CSV-fil.',
    exportButton: 'Ladda ner bokningar',
    deleteInfo: 'Vill du ändra e-postadress eller avsluta kontot? Kontakta receptionen.',
  },
  errors: {
    unauthenticated: 'Du är inte inloggad.',
    two_factor_required: 'Tvåstegsinloggning krävs.',
    two_factor_setup_required: 'Du behöver slå på tvåstegsinloggning först.',
    forbidden: 'Du har inte behörighet till det här.',
    not_found: 'Hittades inte.',
    validation: 'Kontrollera uppgifterna.',
    conflict: 'Rummet är upptaget eller ligger inom 15 minuter från en annan bokning.',
    room_blocked: 'Rummet är blockerat den tiden.',
    block_overlaps_bookings: 'Det finns bokningar under perioden. Avboka dem först.',
    no_access: 'Du saknar behörighet till rummet.',
    over_capacity: 'Rummet rymmer inte så många personer.',
    in_past: 'Tiden har redan passerat.',
    not_editable: 'Bokningen kan inte ändras längre.',
    room_inactive: 'Rummet går inte att boka.',
    forbidden_role_change: 'Du får inte ändra den rollen.',
    actor_inactive: 'Ditt konto är inaktiverat.',
    site_mismatch: 'Fel byggnad.',
    booker_inactive: 'Personen eller företaget är inaktiverat.',
    too_long: 'Bokningen är längre än tillåtet.',
    too_far_ahead: 'Det går inte att boka så långt fram.',
    room_has_future_bookings: 'Rummet har kommande bokningar. Avboka dem först.',
    series_conflicts: 'Några tillfällen krockar.',
    email_taken: 'E-postadressen används redan.',
    invalid_token: 'Länken är ogiltig eller har gått ut.',
    weak_password: 'Lösenordet är för svagt. Använd minst 10 tecken och undvik vanliga lösenord.',
    rate_limited: 'För många försök. Vänta 15 minuter och försök igen.',
    internal: 'Något gick fel. Försök igen om en stund.',
    network: 'Ingen kontakt med servern.',
  },
  admin: {
    tabs: {
      reports: 'Rapporter',
      bookings: 'Bokningar',
      rooms: 'Rum',
      users: 'Användare',
      companies: 'Företag',
      groups: 'Behörighetsgrupper',
      blocks: 'Blockeringar',
      settings: 'Inställningar',
      log: 'Logg',
      monitor: 'Övervakning',
    },
    users: {
      invite: 'Bjud in användare',
      role: 'Roll',
      roles: { tenant: 'Hyresgäst', reception: 'Reception', admin: 'Admin' },
      status: {
        active: 'Aktiv',
        invited: 'Inbjuden, ej aktiv',
        inactive: 'Inaktiverad',
        anonymized: 'Anonymiserad',
      },
      send: 'Skapa och skicka inbjudan',
      sent: 'Inbjudan skickad till {{email}}.',
      manualLink:
        'Kontot är skapat men e-post kunde inte skickas. Ge personen den här länken (den fungerar en gång och gäller i 7 dagar).',
      notSent: 'Kontot är skapat men mejlet kunde inte skickas.',
      resend: 'Skicka ny länk',
      deactivate: 'Inaktivera',
      activate: 'Aktivera',
      changeEmail: 'Byt e-post',
      newEmail: 'Ny e-postadress',
      emailChangeSent: 'En bekräftelse har skickats till den nya adressen.',
      deactivateConfirm: 'Inaktivera {{name}}? Kommande bokningar avbokas. Historiken sparas.',
      deactivated: 'Inaktiverad. {{count}} kommande bokningar avbokades.',
      twofa: '2FA',
      filter: 'Filtrera',
    },
    companies: {
      add: 'Lägg till företag',
      groups: 'Behörighet',
      users: 'Användare',
      deactivateConfirm:
        'Inaktivera {{name}}? Alla användare i företaget loggas ut och kommande bokningar avbokas.',
      lostAccess: 'Bokningar utan behörighet',
      lostAccessIntro:
        'Företaget har kommande bokningar i rum det inte längre har behörighet till. Avgör vad som ska göras med dem.',
    },
    groups: {
      add: 'Ny grupp',
      rooms: 'Rum i gruppen',
      intro: 'Ett företag kan boka rummen i de grupper det tillhör.',
    },
    rooms: {
      add: 'Lägg till rum',
      photos: 'Foton',
      upload: 'Ladda upp foto',
      maxPhotos: 'Högst 10 foton per rum.',
      activeLabel: 'Bokningsbart',
      printSign: 'Skriv ut skylt',
      signText: 'Skanna för att boka',
      capacityWarning: 'Kommande bokningar med fler deltagare än den nya kapaciteten:',
    },
    blocks: {
      new: 'Blockera',
      rooms: 'Rum',
      allRooms: 'Alla rum (stängd dag)',
      reason: 'Orsak',
      created: 'Blockerat.',
      overlapping: 'De här bokningarna ligger inom perioden. Avboka dem först:',
      cancelThese: 'Avboka dessa och meddela personerna',
      removeConfirm: 'Ta bort blockeringen?',
    },
    bookings: {
      filters: 'Filter',
      status: 'Status',
      export: 'Exportera',
      bookFor: 'Boka åt hyresgäst',
      results: '{{count}} bokningar',
    },
    settings: {
      booking: 'Bokningsregler',
      maxMinutes: 'Längsta bokning (minuter, 0 = ingen gräns)',
      maxDays: 'Hur långt fram man får boka (dagar, 0 = ingen gräns)',
      reminder: 'Standardpåminnelse för nya användare (minuter)',
      retention: 'Lagringstider (GDPR, bara admin)',
      bookingMonths: 'Bokningshistorik med namn (månader)',
      deactivatedMonths: 'Anonymisera inaktiverade konton efter (månader)',
      auditMonths: 'Logg sparas (månader)',
      branding: 'Namn och utseende',
      appName: 'Namn på tjänsten',
      color: 'Huvudfärg',
      logo: 'Logotyp',
      uploadLogo: 'Ladda upp logotyp',
      fixed: 'Fast: 15 minuter mellan bokningar, tider i steg om 15 minuter, svensk tid.',
    },
    reports: {
      utilization: 'Beläggning per rum',
      hoursPerCompany: 'Bokade timmar per företag',
      busiest: 'Mest bokade tider',
      weekdays: 'Veckodagar',
      hoursOfDay: 'Tid på dagen',
      period: 'Period',
      room: 'Rum',
      company: 'Företag',
      hours: 'Timmar',
      bookings: 'Bokningar',
      share: 'Beläggning',
      exportXlsx: 'Exportera Excel',
      exportCsv: 'Exportera CSV',
      basis: 'Beläggning räknas mot 08–18 på vardagar.',
    },
    log: { when: 'När', who: 'Vem', what: 'Vad' },
    monitor: {
      health: 'Systemstatus',
      database: 'Databas',
      email: 'E-post',
      integrity: 'Kontroll av data',
      ok: 'OK',
      problems: '{{count}} problem',
      lastJobs: 'Senaste körningar',
      integrityIntro:
        'Kontrollerar att inga bokningar överlappar blockeringar, saknar behörighet eller ligger i inaktiva rum.',
      configured: 'Konfigurerad',
      notConfigured: 'Inte konfigurerad',
    },
  },
} as const;

type Widen<T> = { [K in keyof T]: T[K] extends string ? string : Widen<T[K]> };
export type Messages = Widen<typeof sv>;
